module.exports = __webpack_public_path__ + "img/icon-help.8e2216a7.svg";